import { render, staticRenderFns } from "./CallUs.vue?vue&type=template&id=2cf52a10&scoped=true&"
import script from "./CallUs.vue?vue&type=script&lang=js&"
export * from "./CallUs.vue?vue&type=script&lang=js&"
import style0 from "./CallUs.vue?vue&type=style&index=0&id=2cf52a10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf52a10",
  null
  
)

export default component.exports